"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reverse = reverse;
exports.searchExact = searchExact;
require("core-js/modules/es.array.reverse.js");
function searchExact(needle, haystack) {
  let startIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let endIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return function* () {
    const needleLen = needle.length;
    if (needleLen === 0) return;
    if (endIndex === null) {
      endIndex = haystack.length;
    }
    let index;
    while ((index = haystack.indexOf(needle, startIndex)) > -1) {
      if (index + needle.length > endIndex) break;
      yield index;
      startIndex = index + 1;
    }
  }();
}
function reverse(string) {
  return string.split('').reverse().join('');
}